/**
 * AdSense configuration.
 *
 * Slot IDs are public (they appear in the page source), so they live in code.
 * To create one: AdSense → Ads → By ad unit → Display ads → choose the shape
 * noted below, keep "Responsive", Create, then copy the data-ad-slot value
 * (a 10-digit number) into the matching entry. An empty or malformed slot
 * renders nothing, so no placeholder ad requests are ever sent.
 */

export const ADSENSE_CLIENT = 'ca-pub-9133046126273004';

export const AD_SLOTS = {
  /** "localdiff-header": Display ad, Horizontal shape, responsive. Shown above the workspace. */
  header: '',
} as const;

/** The documentation placeholder that shipped before real units existed. */
const PLACEHOLDER_SLOT = '1234567890';

export function isAdSlotConfigured(slotId: string): boolean {
  return /^\d{10}$/.test(slotId) && slotId !== PLACEHOLDER_SLOT;
}

/**
 * Real impressions only on the production domain. Dev servers, Cloud Run
 * *.run.app URLs and previews request test ads, so their traffic can't be
 * counted as invalid activity against the account.
 */
export function isProductionAdHost(hostname: string): boolean {
  return /(^|\.)localdiff\.dev$/.test(hostname);
}
